export default __webpack_public_path__ + "static/media/refer-and-get-reward-vi.dce6fdbe.svg";